import { ApiResponse } from '../types';
import { sendChatMessage, createSystemMessage, createStandardSystemMessage, validateConfiguration, ChatMessage } from './azureOpenAI';

// 聊天历史存储（在实际应用中可能需要持久化存储）
let chatHistory: ChatMessage[] = [];

// 发送聊天消息
export const sendMessage = async (message: string): Promise<ApiResponse> => {
  try {
    // 验证Azure OpenAI配置
    if (!validateConfiguration()) {
      throw new Error('Azure OpenAI配置不完整，请检查环境变量设置');
    }

    // 检查是否启用了RAG
    const ragEnabled = !!(
      process.env.REACT_APP_AZURE_SEARCH_ENDPOINT && 
      process.env.REACT_APP_AZURE_SEARCH_API_KEY && 
      process.env.REACT_APP_AZURE_SEARCH_INDEX_NAME
    );

    // 构建消息历史
    const messages: ChatMessage[] = [
      ragEnabled ? createSystemMessage() : createStandardSystemMessage(), // 根据RAG状态选择系统提示
      ...chatHistory, // 历史对话
      { role: 'user', content: message } // 当前用户消息
    ];

    // 调用Azure OpenAI
    const assistantReply = await sendChatMessage(messages);

    // 更新聊天历史
    chatHistory.push(
      { role: 'user', content: message },
      { role: 'assistant', content: assistantReply }
    );

    // 限制历史长度（避免token过多）
    if (chatHistory.length > 20) {
      chatHistory = chatHistory.slice(-20);
    }

    return {
      success: true,
      data: {
        message: assistantReply,
        timestamp: new Date().toISOString(),
      }
    };
  } catch (error: any) {
    console.error('发送消息失败:', error);
    return {
      success: false,
      error: error.message || '发送消息失败'
    };
  }
};

// 获取聊天历史
export const getChatHistory = async (): Promise<ApiResponse> => {
  try {
    return {
      success: true,
      data: {
        message: JSON.stringify(chatHistory),
        timestamp: new Date().toISOString(),
      }
    };
  } catch (error: any) {
    return {
      success: false,
      error: '获取聊天历史失败'
    };
  }
};

// 清除聊天历史
export const clearChatHistory = async (): Promise<ApiResponse> => {
  try {
    chatHistory = [];
    return {
      success: true,
      data: {
        message: '聊天历史已清除',
        timestamp: new Date().toISOString(),
      }
    };
  } catch (error: any) {
    return {
      success: false,
      error: '清除聊天历史失败'
    };
  }
}; 